// Input manager: keyboard + touch joystick + boost button.
export class Input {
  constructor() {
    this.keys = {};
    this.joy = { active: false, dx: 0, dy: 0 }; // normalized -1..1
    this.boostBtn = false;
    this.enabled = true; // disabled while typing in chat so keys don't drive the car
    this._onKey = this._onKey.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
  }
  attach() {
    window.addEventListener("keydown", this._onKey);
    window.addEventListener("keyup", this._onKeyUp);
  }
  detach() {
    window.removeEventListener("keydown", this._onKey);
    window.removeEventListener("keyup", this._onKeyUp);
    this.keys = {}; this.joy = { active: false, dx: 0, dy: 0 }; this.boostBtn = false;
  }
  _onKey(e) {
    if (!this.enabled) return;
    const k = e.key.toLowerCase();
    if ([" ", "arrowup", "arrowdown", "arrowleft", "arrowright"].includes(k)) e.preventDefault();
    this.keys[k] = true;
  }
  _onKeyUp(e) { if (!this.enabled) return; this.keys[e.key.toLowerCase()] = false; }

  // returns {throttle:-1..1, steer:-1..1, boost:bool}
  read() {
    if (!this.enabled) return { joystick: false, throttle: 0, steer: 0, boost: false };
    const k = this.keys;
    let throttle = 0, steer = 0;
    if (k["w"] || k["arrowup"]) throttle += 1;
    if (k["s"] || k["arrowdown"]) throttle -= 1;
    if (k["a"] || k["arrowleft"]) steer -= 1;
    if (k["d"] || k["arrowright"]) steer += 1;
    let boost = !!k[" "] || this.boostBtn;
    // joystick overrides direction if active
    if (this.joy.active) {
      const mag = Math.hypot(this.joy.dx, this.joy.dy);
      if (mag > 0.15) return { joystick: true, jx: this.joy.dx, jy: this.joy.dy, boost };
    }
    return { joystick: false, throttle, steer, boost };
  }
}
